module.exports = __webpack_public_path__ + "static/media/complianceAssistant.834a74fc.png";